import { Action, createReducer, on } from "@ngrx/store";
import * as _ from "lodash";

import { MpAdminActions } from "../../actions/mp-admin.actions";
import { ExcessProposalFundsState } from "../../models/mp-admin/excess-proposal-funds-state";

const initialState: ExcessProposalFundsState = {
	loading: true
};

const reducer = createReducer(
	initialState,
	on(MpAdminActions.excessFunds.getApi, (state) => ({ ...state, loading: true })),
	on(MpAdminActions.excessFunds.getSuccess, (state, action) => _.omit(action, "type")),
	on(MpAdminActions.excessFunds.getFail, (state, action) => ({
		...state,
		..._.omit(action, "type")
	}))
);

export function excessFundsReducer(
	state: ExcessProposalFundsState,
	action: Action
): ExcessProposalFundsState {
	return reducer(state, action);
}
